import { useState } from 'react';
import SubPageHeader from '../SubPageHeader';
import SettingsToggle from '../SettingsToggle';
import { toast } from 'sonner';

function usePref(key, def) {
  const [val, setVal] = useState(() => {
    const s = localStorage.getItem(key);
    if (s === null) return def;
    try { return JSON.parse(s); } catch { return s; }
  });
  const set = (v) => { setVal(v); localStorage.setItem(key, JSON.stringify(v)); };
  return [val, set];
}

export default function SecuritySection({ onBack }) {
  const [biometric, setBiometric] = usePref('sec_biometric', false);
  const [autoLock, setAutoLock] = usePref('sec_auto_lock', '5');
  const [crashReports, setCrashReports] = usePref('sec_crash_reports', true);
  const [analytics, setAnalytics] = usePref('sec_analytics', false);

  return (
    <div className="flex flex-col min-h-full" dir="rtl">
      <SubPageHeader title="الأمان والخصوصية" onBack={onBack} />
      <div className="p-4 space-y-4">

        {/* Authentication */}
        <div className="bg-card border border-border rounded-2xl p-4 space-y-1">
          <p className="font-bold text-sm text-foreground mb-3">🔐 المصادقة</p>
          <button onClick={() => toast.info('يمكن تغيير كلمة المرور من إعدادات Odoo')}
            className="w-full flex items-center gap-3 py-3 px-1 border-b border-border hover:bg-muted/30 transition-colors text-right">
            <span className="text-base w-6 text-center">🔑</span>
            <span className="flex-1 text-sm font-medium text-foreground">تغيير كلمة المرور</span>
            <span className="text-xs text-muted-foreground">→</span>
          </button>
          <button onClick={() => toast.info('سجل الدخول غير متاح في هذا الإصدار')}
            className="w-full flex items-center gap-3 py-3 px-1 hover:bg-muted/30 transition-colors text-right">
            <span className="text-base w-6 text-center">📋</span>
            <span className="flex-1 text-sm font-medium text-foreground">سجل تسجيلات الدخول</span>
            <span className="text-xs text-muted-foreground">→</span>
          </button>
        </div>

        {/* Biometric */}
        <div className="bg-card border border-border rounded-2xl p-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <span className="text-2xl">👆</span>
              <div>
                <p className="font-bold text-sm text-foreground">قفل البصمة</p>
                <p className="text-xs text-muted-foreground">تطلب بصمة عند فتح التطبيق</p>
              </div>
            </div>
            <SettingsToggle enabled={biometric} onToggle={(v) => { setBiometric(v); toast.success(v ? 'تم تفعيل قفل البصمة' : 'تم إيقاف قفل البصمة'); }} />
          </div>
        </div>

        {/* App Lock */}
        <div className="bg-card border border-border rounded-2xl p-4">
          <p className="font-bold text-sm text-foreground mb-3">⏱️ قفل تلقائي</p>
          <p className="text-xs text-muted-foreground mb-3">قفل التطبيق بعد فترة خمول</p>
          <div className="grid grid-cols-4 gap-2">
            {['1', '5', '15', '30'].map(m => (
              <button key={m} onClick={() => { setAutoLock(m); toast.success(`سيتم القفل بعد ${m} دقائق`); }}
                className={`py-2 rounded-xl text-sm font-bold border-2 transition-all ${autoLock === m ? 'border-primary bg-primary/5 text-primary' : 'border-border text-foreground'}`}>
                {m}د
              </button>
            ))}
          </div>
        </div>

        {/* Privacy */}
        <div className="bg-card border border-border rounded-2xl p-4 space-y-1">
          <p className="font-bold text-sm text-foreground mb-3">🔏 الخصوصية</p>

          <div className="flex items-center justify-between py-2.5 border-b border-border">
            <div className="flex items-center gap-2">
              <span className="text-sm">🐛</span>
              <span className="text-sm text-foreground">مشاركة تقارير الأعطال</span>
            </div>
            <SettingsToggle enabled={crashReports} onToggle={setCrashReports} />
          </div>

          <div className="flex items-center justify-between py-2.5">
            <div className="flex items-center gap-2">
              <span className="text-sm">📊</span>
              <span className="text-sm text-foreground">مشاركة بيانات الاستخدام</span>
            </div>
            <SettingsToggle enabled={analytics} onToggle={setAnalytics} />
          </div>
        </div>

        {/* Legal */}
        <div className="bg-card border border-border rounded-2xl p-4 space-y-1">
          <p className="font-bold text-sm text-foreground mb-3">📜 القانونية</p>
          {[
            ['📋', 'سياسة الخصوصية'],
            ['📄', 'شروط الخدمة'],
          ].map(([icon, label]) => (
            <button key={label} onClick={() => toast.info('قريباً...')}
              className="w-full flex items-center gap-3 py-3 px-1 border-b border-border last:border-0 hover:bg-muted/30 transition-colors text-right">
              <span className="text-base w-6 text-center">{icon}</span>
              <span className="flex-1 text-sm font-medium text-foreground">{label}</span>
              <span className="text-xs text-muted-foreground">→</span>
            </button>
          ))}
        </div>

      </div>
    </div>
  );
}